




























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import AbcToolButton from "../../button/AbcToolButton.vue";
import { ViewType } from "../../date-picker/private/Utils";

@Component({
    components: {
        AbcToolButton,
    },
})
export default class CalendarHeader extends Vue {
    @Prop() curView!: ViewType;

    private curViewInner = this.curView;

    @Watch("curViewInner")
    private onChange(){
        this.$emit("change-view", this.curViewInner);
    }

}
